module.exports = __webpack_public_path__ + "static/media/LoginBarToken.a4aafaa5.svg";